goog.declareModuleId('yext.storm.router');

/**
 * A modernized version of routes.js which doesn't rely on goog.
 * Should be usable in any babystorm now that we no longer support legacy browsers.
 * @param {string} path within storm with placeholders
 * @return {function(!Object=): string} to be called with key/values
 */
export function route(path) {
  return function(obj = {}) {
    let pattern = '/s/' + window['businessId'] + '/' + path;
    const queryParams = [];
    Object.entries(obj).forEach(([key, vals]) => {
      if (!Array.isArray(obj[key])) {
        vals = [obj[key]];
      }
      for (let i = 0; i < vals.length; i++) {
        const val = encodeURIComponent(vals[i]);
        const pattern2 = pattern.replace(':'+key, val);
        if (pattern === pattern2) {
          queryParams.push(key + '=' + val);
        }
        pattern = pattern2;
      }
    });
    if (queryParams.length > 0) {
      pattern += '?' + queryParams.join('&');
    }
    return pattern;
  };
}
